export default {
  dataView: 'Data View',
  close: 'Close',
  refresh: 'Refresh',
  saveAsImage: 'Save as Image'
}
